
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const AttractPage = lazy(() => import('../pages/attract/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Kiosk pages
const KioskWelcomePage = lazy(() => import('../pages/kiosk/welcome/page'));
const KioskIdentificationPage = lazy(() => import('../pages/kiosk/identification/page'));
const KioskNewPatientPage = lazy(() => import('../pages/kiosk/new-patient/page'));
const KioskDemographicsPage = lazy(() => import('../pages/kiosk/demographics/page'));
const KioskInsurancePage = lazy(() => import('../pages/kiosk/insurance/page'));
const KioskConsentPage = lazy(() => import('../pages/kiosk/consent/page'));
const KioskCompletionPage = lazy(() => import('../pages/kiosk/completion/page'));
const KioskAppointmentsPage = lazy(() => import('../pages/kiosk/appointments/page'));
const KioskPaymentPage = lazy(() => import('../pages/kiosk/payment/page'));
const KioskVisitorPage = lazy(() => import('../pages/kiosk/visitor/page'));
const KioskVisitorCompletionPage = lazy(() => import('../pages/kiosk/visitor-completion/page'));
const KioskWayfindingPage = lazy(() => import('../pages/kiosk/wayfinding/page'));
const KioskAICheckinPage = lazy(() => import('../pages/kiosk/ai-checkin/page'));

// Demo pages
const DemoCheckinPage = lazy(() => import('../pages/demo/checkin/page'));
const DemoMapPage = lazy(() => import('../pages/demo/map/page'));

// Directory pages
const DirectoryHomePage = lazy(() => import('../pages/directory/home/page'));
const DirectoryListPage = lazy(() => import('../pages/directory/list/page'));
const DirectoryMapPage = lazy(() => import('../pages/directory/map/page'));
const DirectorySearchPage = lazy(() => import('../pages/directory/search/page'));

// Staff pages
const StaffDashboardPage = lazy(() => import('../pages/staff/dashboard/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AttractPage />,
  },
  {
    path: '/home',
    element: <HomePage />,
  },
  {
    path: '/attract',
    element: <AttractPage />,
  },
  {
    path: '/kiosk/welcome',
    element: <KioskWelcomePage />,
  },
  {
    path: '/kiosk/identification',
    element: <KioskIdentificationPage />,
  },
  {
    path: '/kiosk/new-patient',
    element: <KioskNewPatientPage />,
  },
  {
    path: '/kiosk/demographics',
    element: <KioskDemographicsPage />,
  },
  {
    path: '/kiosk/insurance',
    element: <KioskInsurancePage />,
  },
  {
    path: '/kiosk/consent',
    element: <KioskConsentPage />,
  },
  {
    path: '/kiosk/completion',
    element: <KioskCompletionPage />,
  },
  {
    path: '/kiosk/appointments',
    element: <KioskAppointmentsPage />,
  },
  {
    path: '/kiosk/payment',
    element: <KioskPaymentPage />,
  },
  {
    path: '/kiosk/visitor',
    element: <KioskVisitorPage />,
  },
  {
    path: '/kiosk/visitor-completion',
    element: <KioskVisitorCompletionPage />,
  },
  {
    path: '/kiosk/wayfinding',
    element: <KioskWayfindingPage />,
  },
  {
    path: '/kiosk/ai-checkin',
    element: <KioskAICheckinPage />,
  },
  {
    path: '/demo/checkin',
    element: <DemoCheckinPage />,
  },
  {
    path: '/demo/map',
    element: <DemoMapPage />,
  },
  {
    path: '/directory/home',
    element: <DirectoryHomePage />,
  },
  {
    path: '/directory/list/:category',
    element: <DirectoryListPage />,
  },
  {
    path: '/directory/map',
    element: <DirectoryMapPage />,
  },
  {
    path: '/directory/search',
    element: <DirectorySearchPage />,
  },
  {
    path: '/staff/dashboard',
    element: <StaffDashboardPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
